<template>
    <div class="exportRecordsRr">
        <div class="section" style="box-shadow: none">
            <div class="search">
                <div class="left">
                    <!-- <span class="search-label">日期</span> -->
                    <div class="datePreNext">
                        <!-- <span class="date-icon"></span> -->
                        <el-date-picker v-model="datevalue" type="date" @change="getData(true)" :editable="false" 
                            clearable :picker-options="pickerrangeOptions" value-format="yyyy-MM-dd"
                            :placeholder="$t('shuoriExport.data')" popper-class="select-date">
                        </el-date-picker>
                    </div>
                </div>
                <div class="right">
                    <!-- <el-button class="button button-solid" @click.stop="showSearchBtn">
                        <i class="el-icon-search"></i>
                    </el-button> -->
                    <el-button type="text" class="button-export" :disabled="exportReportMonthLoad"  @click="exportReport()">{{$t('shuoriExport.export')}}</el-button>
                    <div class="search-alert" v-if="showSearch">
                        <div class="searchDiv">
                            <el-input class="searchAll" ref="iptFocus" v-model.trim="search.search"
                                @keyup.enter.native="getData(true)" :placeholder="$t('alarmNew.fileName')" clearable>
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                            <!-- 搜索 -->
                            <span class="search-device" @click="getData(true)">{{
                                $t("recharge.Search")
                                }}</span>
                            <!-- 取消 -->
                            <span class="search-hide" @click="closeSearch">{{
                                $t("rate.cancel")
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <el-table :data="alarmlist" border stripe height="100%" :row-style="{ height: 0 }"
                :cell-style="{ padding: 0 }" :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
                v-loading="alarmloading" element-loading-spinner="el-icon-loading" class="tablemain tableloding"
                :empty-text="$t('account.nodata')" ref="multipleSnTable">
                <el-table-column prop="filename" min-width="150px;" :label="$t('alarmNew.fileName')"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span >{{decodeURI(scope.row.filename)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" :label="$t('alarmNew.fileStatus')" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">{{
                            $t("alarmNew.can")
                            }}</span>
                        <span v-else>{{ $t("alarmNew.no") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="size" :label="$t('alarmNew.fileSize')"
                    :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="gts" min-width="85px;" :label="$t('account.createTime')"
                    :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="progress" :label="$t('alarmNew.progress')" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.progress + "%" }}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="$t('alarm.Operation')" width="100">
                    <template slot-scope="scope">
                        <!-- 下载 -->
                        <el-button type="text" class="operation" :title="$t('firmware.downloadFirmware')"
                            @click="exportDownLoad(scope.row)" v-if="scope.row.status == 1">
                            <i class="el-icon-download"></i>
                        </el-button>
                        <!-- 刷新 -->
                        <el-button type="text" class="operation" :title="$t('device.refresh')" v-else @click="getData()">
                            <i class="iconfont icon-refresh"></i>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tablebottom">
                <!-- 批量占位 -->
                <span class="" style="margin-left: 16px"></span>
                <el-pagination class="pagination" background @size-change="getData(true)"
                    @current-change="() => getData()" :current-page.sync="pagination.currentPage"
                    :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
                    layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total"
                    popper-class="select-page">
                    <span style="color: #ffffff; padding-left: 15px">{{ $t("device.pageSize") }} :</span>
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import deletesalarmDialog from "@/components/dialognew";
import { mapGetters } from "vuex";
import { i18n } from "@/i18n";
export default {
    components: {
        deletesalarmDialog, //删除弹框
    },
    data() {
        return {
            exportReportMonthLoad: false,
            alarmloading: false,
            search: {
                search: "",
            },
            alarmlist: [],
            pagination: {
                currentPage: 1,
                total: 0,
                pagesize: 15,
            }, // 分页数据
            showSearch: false,
            datevalue: "",
            //自定义日期选择限定31天
            pickerrangeOptions: {
                disabledDate: (time) => {
                    return time.getTime() > Date.now() - 8.64e6;
                },
            },
            vcodeBox: "", //厂家编码
        };
    },
    mounted() {
        this.getVcodeData();
        this.getData();
    },
    computed: {
        ...mapGetters({
            deviceInfo: "getDeviceInfo",
        }),
    },
    watch: {

    },
    methods: {
         getVcodeData() {
          this.$request.get("queryVendorCode").then((res) => {
            if (res.err == 0) {
              this.vcodeBox = res.dat.vendorcode[0].code;
            }
          });
        },
        // 打开搜索栏
        showSearchBtn() {
            this.search = {
                search: "",
            };
            this.datevalue = "";
            this.showSearch = true;
            this.$nextTick(() => {
                this.$refs.iptFocus.focus();
            });
        },
        // 关闭搜索框
        closeSearch() {
            this.showSearch = false;
            this.search.search = "";
            this.getData(true);
        },
        //获取表格数据
        getData(reset) {
            if (reset) this.pagination.currentPage = 1;
            let param = {
            //   ...this.search,
              gts: this.datevalue ? this.datevalue : "",
            //   devtype: 2304,
              i18n: this.$lang.currentLang,
              pagesize: this.pagination.pagesize,
              page: this.pagination.currentPage - 1,
            };
            this.alarmloading = true;
            this.$request.get("queryTaskFile", param).then((res) => {
              if (res.err == 0) {
                this.alarmlist = res.dat.list;
                this.pagination.total = res.dat.total;
              } else {
                this.alarmlist = [];
                this.pagination.total = 0;
              }
              this.alarmloading = false;
            });
        },
        exportReport(){
          let param = {
              vcode: this.vcodeBox,
              i18n: this.$lang.currentLang,
          };
          this.exportReportMonthLoad = true;
          this.$request.get("exportVendorPlantDetails", param).then((res) => {
            this.exportReportMonthLoad = false;
            if (res.err == 0) {
                this.getData();
                this.$message.success(i18n.t("shuoriExport.exportTask"));
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
        },
        exportDownLoad(row) {
            let param = {
                action: "downLoadFile",
                i18n: this.$lang.currentLang,
                id: row.id,
            };
            // window.open(this.$request.http_download_url_new(param));
           fetch(this.$request.http_download_url_new(param), { method: 'HEAD' })
                .then(res => {
                    console.log(res,this.$request.http_download_url_new(param));
                    if (res.ok) {
                        // 可下载，直接新窗口下载
                        window.open(this.$request.http_download_url_new(param), '_blank');
                    } else {
                        this.$message.error(i18n.t("shuoriExport.noDownload"));
                    }
                })
                .catch(() => {
                    this.$message.error(i18n.t("shuoriExport.noDownload"));
            });
            // // row.file 是文件地址
            // if (!row.file) {
            //     this.$message.error('无效的文件地址');
            //     return;
            // }
            // // 先用 HEAD 请求判断文件是否可下载
            // fetch(row.file, { method: 'HEAD' })
            //     .then(res => {
            //         if (res.ok) {
            //             // 可下载，直接新窗口下载
            //             window.open(row.file, '_blank');
            //         } else {
            //             this.$message.error('文件地址无效或无法下载');
            //         }
            //     })
            //     .catch(() => {
            //         this.$message.error('文件地址无效或无法下载');
            // });
        },
    },
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.exportRecordsRr {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-top: 0px;
    padding: 20px;

    .button-export {
        height: 48px;
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        border-radius: 0px;
        border: none;
        // cursor: pointer;
    }
    // 统一按钮
    .btn {
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
    }

    .btn-disable {
        color: rgba(242, 242, 242, 0.5);
        background: rgba(43, 56, 66, 1);
        cursor: not-allowed;
    }

    .btn-dark {
        background: @primaryTextColor;
        color: rgba(34, 45, 53, 1);
        border: none;
    }

    .btn-light {
        background: transparent;
        color: @primaryTextColor;
        border: 1px solid @primaryTextColor;
    }
    .section {
        display: flex;
        flex: 1;
        padding: 0px;
        flex-direction: column;
        border-radius: 0px;
        border: none;
        background: rgb(34, 45, 53);
        position: relative;
        // overflow: auto;
        overflow: hidden;

        /deep/.el-icon-loading {
            font-size: 28px;
        }

        .search {
            margin: 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgb(34, 45, 53);

            .search-alert {
                position: absolute;
                top: 0;
                // left: 0;
                right: 0;
                width: 100%;
                height: 48px;
                z-index: 1;
                background: rgb(34, 45, 53);
                display: flex;
                align-items: center;
                justify-content: space-between;

                .searchDiv {
                    position: absolute;
                    top: 0;
                    // left: 0;
                    right: 0;
                    width: 400px;
                    height: 48px;
                    z-index: 2;
                    background: rgb(34, 45, 53);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .searchAll {
                    /deep/.el-input__inner {
                        width: 220px;
                        padding-left: 10px !important;
                    }
                }

                .search-device {
                    display: inline-block;
                    line-height: 48px;
                    padding: 0 15px;
                    font-size: 14px;
                    background: #202d35;
                    color: #33ffb6;
                    cursor: pointer;

                    &:hover {
                        background: @primaryColorTransparency30;
                        color: rgb(255, 255, 255, 1);
                    }
                }

                .search-hide {
                    display: inline-block;
                    // position: absolute;
                    // right: -58px;
                    // line-height: 48px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0 15px;
                    font-size: 14px;
                    background: #202d35;
                    color: #7b8395;
                    border-left: 1px solid #7b8395;
                    cursor: pointer;

                    &:hover {
                        background: @primaryColorTransparency30;
                        color: rgb(255, 255, 255, 1);
                    }
                }

                /deep/.el-input {
                    flex: 1;
                }

                /deep/.el-input .el-input__clear {
                    width: 48px;
                    color: #7b8395;
                }

                /deep/.el-input .el-input__clear:hover {
                    background: @primaryColorTransparency30;
                    color: rgb(255, 255, 255, 1);
                }

                /deep/.el-input .el-input__inner,
                /deep/.el-input .el-input__inner:hover {
                    height: 48px;
                    border-radius: 0px;
                    border: none;
                    background: #202d35;
                    color: #ffffff;
                    padding-left: 40px;
                }

                /deep/.el-input__prefix {
                    left: -20px;
                }

                /deep/.el-input__icon {
                    width: 40px;
                }

                /deep/.el-input__suffix {
                    right: 0px;
                }

                /deep/.el-input__suffix:hover {
                    background: @primaryColorTransparency30;
                    color: rgb(255, 255, 255, 1);
                }

                /deep/.el-icon-circle-close:before {
                    content: "X";
                }

                /deep/.el-input:not(:last-child) {
                    margin-right: 0px;
                }
            }

            .left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }

            // 日期盒子
            .datePreNext {
                padding: 0px 16px;
                // border-left: 1px solid #7B8395;
                border-right: 1px solid #7B8395;

                /deep/.el-date-editor.el-input {
                    width: 180px;
                }

                /deep/.el-date-editor.el-input .el-input__inner {
                    padding: 0px;
                    text-align: center;
                }

                //.el-input__prefix,
                //.el-input__suffix
                /deep/.el-input__prefix {
                    // display: none;
                    left: 5px;
                    right: auto;
                    // .el-input__icon{
                    //     width: 100%;
                    // }
                }

                // /deep/.el-input__suffix {
                //     top: 2px;
                //     right: 16px;
                // }

                // .date-icon {
                //     display: inline-block;
                //     width: 24px;
                //     height: 24px;
                //     background: url(../../../assets/img/general/Icon_Calendar.png);
                //     background-size: 100%;
                //     background-position: center;
                //     background-repeat: no-repeat;
                //     vertical-align: middle;
                // }
                // .date-btn {
                //     color: #ffffff;
                //     cursor: pointer;
                //     display: inline-block;
                //     height: 16px;
                //     width: 16px;
                //     background-size: 100%;
                //     background-position: center;
                //     background-repeat: no-repeat;
                //     vertical-align: middle;
                // }
            }

            .search-label {
                display: inline-block;
                color: #ffffff;
                font-weight: bold;
                line-height: 48px;
                font-size: 14px;
                padding-left: 16px;
            }

            /deep/.el-select {
                width: 100px;
                border-right: 1px solid #738089;
            }

            /deep/.el-select:hover {
                background: @primaryColorTransparency30;
            }

            /deep/.el-select:not(:last-child),
            /deep/.search .el-input:not(:last-child) {
                margin-right: 0px;
            }

            /deep/.el-input {
                width: 100%;
                text-align: center;
            }

            /deep/.el-input__inner {
                background: transparent;
                border: none;
                height: 48px;
                line-height: 48px;
                color: #ffffff;
                padding: 0 16px;
            }

            /deep/.el-input__suffix {
                right: 0px;
            }

            .button {
                height: 48px;
                line-height: 48px;
                padding: 0 25px;
                margin-top: 0px;
                color: @primaryTextColor;
                background: transparent;
                border: none;
            }
        }

        // 批量操作弹条
        .batch-alert {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 48px;
            z-index: 1;
            background: rgba(255, 231, 107, 1);
            display: flex;
            align-items: center;
            justify-content: space-between;

            .batch-total {
                padding-left: 16px;
                font-size: 14px;
            }

            .batch-right {
                display: flex;
                justify-content: flex-end;
            }

            .batch-hide {
                height: 48px;
                line-height: 48px;
                padding: 0px 16px;
                cursor: pointer;
                font-size: 14px;

                &:hover {
                    background: rgba(255, 255, 255, 1);
                }
            }

            .batch-operate {
                display: flex;
                justify-content: flex-end;

                .btn {
                    color: rgba(34, 45, 53, 1);
                    font-size: 14px;
                    cursor: pointer;
                    // display: inline-block;
                    height: 48px;
                    line-height: 48px;
                    padding: 0px 16px;
                    border-radius: 0px;
                    display: flex;
                    align-items: center;

                    &:hover {
                        background: rgba(255, 255, 255, 1);
                    }
                }

                .ico-copy {
                    background: url(../../../assets/img/general/Icon_Batch_Copy.png);
                }

                .ico-export {
                    background: url(../../../assets/img/general/Icon_Batch_Export.png);
                }

                .ico-clear {
                    background: url(../../../assets/img/general/Icon_Batch_Delete.png);
                }

                .ico-more {
                    background: url(../../../assets/img/general/Icon_Batch_More.png);
                }

                .ico {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    background-repeat: no-repeat;
                    background-size: 100%;
                    background-position: center;
                    margin-left: 8px;
                }

                // 批量更多下拉 (不可scoped)(.dropdown-more)
            }
        }

        .tableloding {

            // 加载数据时遮罩
            /deep/.el-loading-mask {
                background-color: rgb(34, 45, 53, 0.5);
            }

            /deep/.el-loading-spinner i {
                color: @primaryTextColor;
            }
        }

        .tablemain {
            border: none;
            background-color: rgb(34, 45, 53);

            .operation i {
                color: @primaryTextColor;
            }


            /deep/.el-table--border::after,
            /deep/.el-table--group::after {
                width: 0px;
            }

            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
                width: 16px;
                height: 16px;
                background: transparent;
                border: 1px solid rgb(180, 184, 193);
                border-radius: 0px;
            }

            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
                top: 2px;
                left: 5px;
            }

            /deep/.el-table__header th {
                height: 48px;
            }

            /deep/.el-table__header th.is-leaf {
                border-color: rgba(198, 209, 221, 0.5);
                // border-bottom: none;
            }

            /deep/.el-table__header th>.cell {
                font-weight: normal;
                font-size: 12px;
            }

            /deep/.el-table__body tr,
            /deep/.el-table__body td {
                background-color: rgb(34, 45, 53);
                color: #ffffff;
                border-color: rgba(198, 209, 221, 0.5);
            }

            /deep/.el-table__body td.el-table-column--selection {
                background-color: rgb(65, 80, 90);
                color: #ffffff;
            }

            /deep/.el-table__body .cell.el-tooltip {
                font-size: 14px;
            }

            // 右侧固定
            /deep/.el-table__fixed-right::before,
            /deep/.el-table__fixed::before {
                display: none;
            }

            ::-webkit-scrollbar {
                width: 6px;
                height: 6px;
                background-color: #222d35;
            }

            /deep/.el-table--border::after,
            /deep/.el-table--group::after {
                display: none;
            }
            // 关于头部右侧空白
            /deep/.el-table__fixed-right-patch {
                background-color: rgb(65, 80, 90);
                border-bottom: none;
            }

            /deep/th.gutter {
                background-color: rgb(65, 80, 90);
            }
        }

        .tablebottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid rgba(198, 209, 221, 0.5);

            // 分页
            .pagination {
                line-height: 48px;
                height: 48px;
                padding: 0;
                margin: 0;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-right: 16px;

                /deep/.el-pager li {
                    vertical-align: middle;
                }

                /deep/.el-select .el-input {
                    width: 90px;
                    margin: 0px;
                }

                /deep/.el-input .el-input__inner {
                    background-color: #202d35;
                    color: #ffffff;
                }

                /deep/.el-input__suffix {
                    right: 10px;
                }

                /deep/.el-pagination__sizes {
                    margin: 0px;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pagination__total {
                    color: #fff;
                    padding-left: 15px;
                    border-left: 1px solid #7b8395;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pager li:not(.disabled).active {
                    // background: #15C491;
                    // color: #ffffff;
                    background-color: #2b3842;
                    color: #15c491;
                }

                // li:not(.disabled):not(.active):hover
                /deep/.el-pager li:not(.disabled):hover {
                    background-color: @primaryColorTransparency30;
                    color: rgba(255, 255, 255, 1);
                }

                /deep/.el-pager li {
                    background-color: #2b3842;
                    color: #7b8395;
                }

                // 页条数下拉
                /deep/.el-select .el-input .el-input__inner {
                    border: none;
                    height: 48px;
                    line-height: 48px;
                    border-radius: 0px;
                }

                /deep/.el-select .el-input .el-input__inner:hover {
                    background: @primaryColorTransparency30;
                }

                // 跳页
                /deep/.el-pagination__jump {
                    color: #ffffff;
                }

                /deep/.el-pagination__editor {
                    padding: 0px 6px;
                }

                /deep/.el-pagination__editor.el-input .el-input__inner {
                    border: 1px solid #7b8395;
                }
            }

            // 分页前后按钮
            /deep/.el-pagination.is-background .btn-next,
            /deep/.el-pagination.is-background .btn-prev {
                background-color: #2b3842;
                color: #7b8395;
            }

            /deep/.el-pagination.is-background .btn-next:hover,
            /deep/.el-pagination.is-background .btn-prev:hover {
                background-color: @primaryColorTransparency30;
                color: rgba(255, 255, 255, 1);
            }

            /deep/.el-pagination.is-background button[disabled],
            /deep/.el-pagination.is-background button[disabled]:hover {
                background-color: #2b3842;
                color: #7b8395;
            }
        }
    }
    /deep/.el-icon-date:before {
        content: "";
        display: inline-block;
        position: absolute;
        top: 12px;
        left: 10px;
        height: 24px;
        width: 24px;
        background: url(../../../assets/img/general/Icon_Calendar.png) no-repeat;
        background-size: 100%;
        background-position: center;
    }
    // Loading
    .el-loading-spinner .path {
        stroke: @primaryTextColor !important;
    }
}
</style>
